/** True for a plain object-like value: non-null, `typeof 'object'`, and not an array. */
export const isRecord = (value: unknown): value is Readonly<Record<string, unknown>> => typeof value === 'object' && value !== null && !Array.isArray(value);
